/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S3_R5_PurposeInputs */

const tr_cerez_s3_r5_purpose = /** @type {(inputs: Cerez_S3_R5_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çerez bilgilendirmesinin görüldüğünün kaydı (yerel depolama)`)
};

const en_cerez_s3_r5_purpose = /** @type {(inputs: Cerez_S3_R5_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record that the cookie notice has been seen (local storage)`)
};

const de_cerez_s3_r5_purpose = /** @type {(inputs: Cerez_S3_R5_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichert, dass der Cookie-Hinweis gesehen wurde (lokaler Speicher)`)
};

const ru_cerez_s3_r5_purpose = /** @type {(inputs: Cerez_S3_R5_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запись о просмотре уведомления о cookie (локальное хранилище)`)
};

/**
* | output |
* | --- |
* | "Record that the cookie notice has been seen (local storage)" |
*
* @param {Cerez_S3_R5_PurposeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s3_r5_purpose = /** @type {((inputs?: Cerez_S3_R5_PurposeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S3_R5_PurposeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s3_r5_purpose(inputs)
	if (locale === "de") return de_cerez_s3_r5_purpose(inputs)
	if (locale === "ru") return ru_cerez_s3_r5_purpose(inputs)
	return tr_cerez_s3_r5_purpose(inputs)
});